/**
 * Force-dealer-30 layer — when everyone before the dealer passes,
 * the dealer must open with at least 30 points instead of passing.
 */

import type { Layer } from './types';
import { BID_TYPES, GAME_CONSTANTS } from '../constants';

export const forceDealer30Layer: Layer = {
  name: 'forceDealer30',

  getValidActions: (state, prev) => {
    if (state.phase !== 'bidding') {
      return prev;
    }

    const nonPassBids = state.bids.filter((bid) => bid.type !== BID_TYPES.PASS);
    const passCount = state.bids.filter((bid) => bid.type === BID_TYPES.PASS).length;

    // Dealer must bid when three others passed with no contract.
    if (
      nonPassBids.length === 0 &&
      passCount === 3 &&
      state.currentPlayer === state.dealer
    ) {
      const filtered = prev.filter((action) => action.type !== 'pass' && action.type !== 'redeal');
      const hasOpeningBid = filtered.some(
        (action) =>
          action.type === 'bid' &&
          action.bid === BID_TYPES.POINTS &&
          action.value === GAME_CONSTANTS.MIN_BID,
      );

      if (!hasOpeningBid) {
        return [
          ...filtered,
          {
            type: 'bid',
            player: state.dealer,
            bid: BID_TYPES.POINTS,
            value: GAME_CONSTANTS.MIN_BID,
          },
        ];
      }

      return filtered;
    }

    // Safety: if all four passed, assign dealer 30 instead of redeal.
    if (state.bids.length === 4 && nonPassBids.length === 0) {
      return [
        {
          type: 'bid',
          player: state.dealer,
          bid: BID_TYPES.POINTS,
          value: GAME_CONSTANTS.MIN_BID,
          autoExecute: true,
          meta: { authority: 'system', reason: 'force-dealer-30' },
        },
      ];
    }

    return prev;
  },
};
